/** Reports > Arrival: the legacy arrival reports as one list (user, 2026-10-17). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { ArrivalReportsIndexPage } from "@/features/reports/arrival-reports-page";

export const Route = createFileRoute("/_app/reports/arrival/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("reports.arrival"))
      throw redirect({ to: "/reports" });
  },
  component: ArrivalReportsIndexPage,
});
